export default {
  "b2b.navigation.title": "B2B Portál",
  "b2b.navigation.item.prehled": "Přehled",
  "b2b.navigation.item.rezervace": "Rezervace",
  "b2b.navigation.item.casovy-plan": "Časový plán",
  "b2b.navigation.item.historie": "Historie žádostí",
  "b2b.navigation.item.rezervace.odbaveni": "Odbavení žádostí",
  "b2b.navigation.item.rezervace.vytvoreni": "Nová rezervace",
  "b2b.navigation.item.provozni-informace": "Provozní informace",
  "b2b.navigation.item.administrace": "Administrace",
  "b2b.navigation.item.administrace.zakaznici": "Zákazníci",
  "b2b.navigation.item.administrace.zdroje": "Zdroje",
  "b2b.navigation.item.administrace.konfiguracni-parametry": "Parametry"
};
